export var getGrossSum = function (data) {
    var valueBnh = data.bnh.positionsSummary.grossUnrealizedPnlSum.value;
    var valueLimited = data.limited.positionsSummary.grossUnrealizedPnlSum.value;
    var valueUnlimited = data.unlimited.positionsSummary.grossUnrealizedPnlSum.value;
    var valueStocks = data.stocks.positionsSummary.grossUnrealizedPnlSum.value;
    return +valueBnh + +valueLimited + +valueUnlimited + +valueStocks;
};
export var getInvestSum = function (data) {
    var valueBnh = data.bnh.positionsSummary.investmentSum.value;
    var valueLimited = data.limited.positionsSummary.investmentSum.value;
    var valueUnlimited = data.unlimited.positionsSummary.investmentSum.value;
    var valueStocks = data.stocks.positionsSummary.investmentSum.value;
    return +valueBnh + +valueLimited + +valueUnlimited + +valueStocks;
};
//# sourceMappingURL=helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/UserBlock/components/Balance/helpers.js
// module id = 1363
// module chunks = 118